/* Laser projection section — Laserman Technologies.
   Vanilla JS, no dependencies, no build step. Everything is scoped to the
   #lm-projection container so it cannot collide with the Shopify theme.

   Replaces the React behaviour of the original standalone page:
     - industry tab switching
     - per-industry media gallery (arrows, dots, keyboard)
     - full-size photo lightbox
     - FAQ accordion
     - "Talk to us about X" pre-filling the enquiry form
*/
(function () {
  'use strict';

  var root = document.getElementById('lm-projection');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollToContact() {
    var el = root.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------------------------------------------------------------- tabs -- */

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-industry]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

  function selectIndustry(id, focusTab) {
    tabs.forEach(function (t) {
      var on = t.dataset.industry === id;
      t.classList.toggle('active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var on = p.dataset.panel === id;
      p.hidden = !on;
      if (on) showSlide(p, 0);
    });
    if (focusTab) {
      var t = tabs.filter(function (x) { return x.dataset.industry === id; })[0];
      if (t) t.focus();
    }
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { selectIndustry(tab.dataset.industry); });
    tab.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') next = tabs[0];
      else if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) { e.preventDefault(); selectIndustry(next.dataset.industry, true); }
    });
  });

  /* ------------------------------------------------------------- gallery -- */

  function slidesOf(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('[data-slide]'));
  }

  function showSlide(panel, index) {
    var slides = slidesOf(panel);
    if (!slides.length) return;
    var n = slides.length;
    var i = ((index % n) + n) % n;
    slides.forEach(function (s, si) {
      var on = si === i;
      s.hidden = !on;
      if (!on && s.tagName === 'VIDEO' && !s.paused) s.pause();
    });
    panel.querySelectorAll('[data-dot]').forEach(function (d) {
      var on = Number(d.dataset.dot) === i;
      d.classList.toggle('active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var note = panel.querySelector('[data-video-note]');
    if (note) note.hidden = slides[i].tagName !== 'VIDEO';
    panel.dataset.activeSlide = String(i);
  }

  function activeIndex(panel) {
    return Number(panel.dataset.activeSlide || 0);
  }

  panels.forEach(function (panel) {
    panel.dataset.activeSlide = '0';

    panel.querySelectorAll('[data-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showSlide(panel, activeIndex(panel) + (btn.dataset.nav === 'next' ? 1 : -1));
      });
    });
    panel.querySelectorAll('[data-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () { showSlide(panel, Number(dot.dataset.dot)); });
    });

    panel.querySelectorAll('img[data-slide]').forEach(function (img) {
      img.addEventListener('click', function () { openLightbox(panel); });
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(panel); }
      });
    });

    var enquire = panel.querySelector('[data-enquire]');
    if (enquire) {
      enquire.addEventListener('click', function () {
        var select = root.querySelector('#lm-f-industry');
        if (select) select.value = enquire.dataset.enquire;
        var quote = root.querySelector('#lm-intent-0');
        if (quote) quote.checked = true;
        scrollToContact();
      });
    }
  });

  /* ------------------------------------------------------------ lightbox -- */

  var lightbox = null;

  function closeLightbox() {
    if (!lightbox) return;
    document.removeEventListener('keydown', onLightboxKey);
    document.body.style.overflow = lightbox.dataset.prevOverflow || '';
    var opener = lightbox.opener;
    lightbox.remove();
    lightbox = null;
    if (opener && document.contains(opener)) opener.focus();
  }

  function onLightboxKey(e) {
    if (!lightbox) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') stepLightbox(-1);
    else if (e.key === 'ArrowRight') stepLightbox(1);
    else if (e.key === 'Tab') {
      var focusables = lightbox.querySelectorAll('button');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function stepLightbox(delta) {
    if (!lightbox) return;
    var panel = lightbox.panel;
    showSlide(panel, activeIndex(panel) + delta);
    if (slidesOf(panel)[activeIndex(panel)].tagName === 'VIDEO') { closeLightbox(); return; }
    paintLightbox();
  }

  function paintLightbox() {
    var panel = lightbox.panel;
    var slides = slidesOf(panel);
    var i = activeIndex(panel);
    var src = slides[i];
    lightbox.querySelector('.lightbox-img').src = src.getAttribute('src');
    lightbox.querySelector('.lightbox-img').alt = src.getAttribute('alt') || '';
    var count = lightbox.querySelector('.lightbox-count');
    if (count) count.textContent = i + 1 + ' / ' + slides.length;
    lightbox.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + slides.length);
  }

  function openLightbox(panel) {
    var slides = slidesOf(panel);
    var current = slides[activeIndex(panel)];
    if (!current || current.tagName === 'VIDEO') return;

    lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.panel = panel;
    lightbox.opener = current;
    lightbox.dataset.prevOverflow = document.body.style.overflow;

    var multi = slides.length > 1;
    lightbox.innerHTML =
      '<button type="button" class="lightbox-close" aria-label="Close">×</button>' +
      '<img class="lightbox-img" alt="">' +
      (multi
        ? '<button type="button" class="gallery-nav gallery-nav-prev lightbox-nav" aria-label="Previous photo">‹</button>' +
          '<button type="button" class="gallery-nav gallery-nav-next lightbox-nav" aria-label="Next photo">›</button>' +
          '<p class="lightbox-count"></p>'
        : '');

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    lightbox.querySelector('.lightbox-close').addEventListener('click', function (e) {
      e.stopPropagation();
      closeLightbox();
    });
    lightbox.querySelectorAll('.lightbox-nav').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        stepLightbox(btn.classList.contains('gallery-nav-next') ? 1 : -1);
      });
    });
    lightbox.querySelector('.lightbox-img').addEventListener('click', function (e) {
      e.stopPropagation();
    });

    root.appendChild(lightbox);
    paintLightbox();
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onLightboxKey);
    lightbox.querySelector('.lightbox-close').focus();
  }

  /* ----------------------------------------------------------------- faq -- */

  root.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var panel = item.querySelector('.faq-a');
      var open = btn.getAttribute('aria-expanded') === 'true';
      root.querySelectorAll('.faq-item').forEach(function (other) {
        other.classList.remove('open');
        other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        other.querySelector('.faq-a').hidden = true;
      });
      if (!open) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  });

  /* ------------------------------------------------------------ info pack -- */

  var infoPack = root.querySelector('[data-info-pack]');
  if (infoPack && !infoPack.getAttribute('href')) {
    infoPack.addEventListener('click', function () {
      var radios = root.querySelectorAll('input[name="contact[Enquiry type]"]');
      if (radios.length) radios[radios.length - 1].checked = true;
      scrollToContact();
    });
  }

  /* --------------------------------------------- preview-only form stub -- */
  /* On Shopify the form posts to the store and this block never runs.        */

  var previewForm = root.querySelector('[data-preview-form]');
  if (previewForm) {
    previewForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var success = root.querySelector('[data-preview-success]');
      previewForm.hidden = true;
      if (success) {
        success.hidden = false;
        success.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    });
  }

  /* Scroll straight to the thank-you state after a real Shopify submission. */
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    var done = root.querySelector('.form-success');
    if (done) done.scrollIntoView({ behavior: 'auto', block: 'center' });
  }
})();
